export default {
  title: 'I miei documenti',
  description: 'I tuoi documenti aziendali caricati. Puoi scaricarli o sostituirli in qualsiasi momento.',
  document_types: {
    owner_document: "Documento d'identità del titolare",
    business_document: 'Documento aziendale',
  },
  kinds: {
    vat_registration: 'Registrazione IVA',
    trade_registration: 'Registrazione commerciale',
    trade_license: 'Licenza commerciale',
    commercial_register_extract: 'Estratto del registro commerciale',
    financial_statements: 'Bilancio',
    bank_statement: 'Estratto conto bancario',
    shareholder_list: 'Elenco dei soci',
    other: 'Altro',
    passport: 'Passaporto',
    driver_license: 'Patente di guida',
    id_card: "Carta d'identità",
    residence_permit: 'Permesso di soggiorno',
  },
  sides: {
    front: 'Fronte',
    back: 'Retro',
  },
  fields: {
    slot: 'Categoria',
    document: 'Documento',
    kind: 'Tipo',
    side: 'Lato',
    uploaded_at: 'Caricato',
    expires_at: 'Scade',
    retained_until: 'Conservato fino al',
    deleted_at: 'Eliminato',
    storage_deleted_at: 'Eliminato definitivamente',
    actions: 'Azioni',
  },
  values: {
    no_slot: 'Altro',
    no_file_name: '—',
    version: 'v{{version}}',
  },
  filters: {
    type_placeholder: 'Filtra per tipo di documento',
    kind_placeholder: 'Filtra per tipo',
  },
  retention: {
    deletable: 'Eliminabile',
    tooltip:
      'La legge tedesca (GoBD / §147 AO) ci impone di conservare questo documento fino al {{date}}. Può essere eliminato solo dopo tale data.',
    tooltip_no_date:
      'Questo documento è soggetto a un periodo di conservazione obbligatorio e non può ancora essere eliminato.',
  },
  buttons: {
    upload: 'Carica',
    upload_other: 'Altro documento',
    retry_slots: 'Impossibile caricare i documenti: riprova',
    download: 'Scarica',
    download_front: 'Scarica fronte',
    download_back: 'Scarica retro',
    reupload: 'Ricarica',
    delete: 'Elimina',
  },
  empty: 'Non hai ancora caricato alcun documento.',
  delete_modal: {
    title: 'Elimina documento',
    description:
      'Scegli come eliminare questo documento. «Elimina» lo archivia e lo nasconde dalla lista. «Elimina definitivamente» cancella i file in modo permanente ed è possibile solo al termine del periodo di conservazione obbligatorio.',
    delete: 'Elimina',
    permanently_delete: 'Elimina definitivamente',
    cancel: 'Annulla',
    retention_alert:
      "Questi documenti sono soggetti a periodi di conservazione obbligatori ai sensi della legge tedesca (GoBD / §147 AO). L'eliminazione definitiva rimuove i file in modo irreversibile.",
  },
  reupload_modal: {
    title: 'Ricarica documento',
    description: 'Carica una nuova versione di questo documento. La versione precedente verrà sostituita.',
    type: {
      label: 'Tipo di documento',
      placeholder: 'Seleziona tipo di documento',
    },
    kind: {
      label: 'Categoria documento',
      placeholder: 'Seleziona categoria documento',
    },
    front: {
      label: 'Fronte documento',
    },
    back: {
      label: 'Retro documento (opzionale per alcuni documenti)',
    },
    expires_at: {
      label: 'Data di scadenza documento',
      placeholder: 'Seleziona data di scadenza',
    },
    buttons: {
      select_file: 'Seleziona file',
      submit: 'Carica',
      cancel: 'Annulla',
    },
  },
  toasts: {
    download_error: 'Download del documento non riuscito.',
    delete_success: 'Documento eliminato con successo.',
    delete_error: 'Eliminazione del documento non riuscita.',
    reupload_success: 'Documento caricato con successo.',
    reupload_error: 'Caricamento del documento non riuscito.',
  },
};
